import React from 'react';
import SetupTwoFactor from '../../components/two-factor-authentication/SetupTwoFactor';
import Navbar from '../../components/Navbars/Navbar2';
import Footer from '../../components/Footer/Footer';
import {permColors} from '../../utils/colors';

export default function TwoFactorAuthenticationSetupPage() {
	return (
		<div>
			<Navbar style={{}} />
			<div className="max-w-3xl mx-auto p-2 my-4">
				<SetupTwoFactor />
			</div>
			<Footer backgroundColor={permColors.backgroundGreyBlue} />
		</div>
	);
}
